const DIC = {
  LABLE: 'dictLabel',
  VALUE: 'dictValue',
  TYPE: 'dictType'
}

const DictUtil = {

  dictLabel(datas, value) {// 获取字典label
    const actions = []
    if (datas && datas.length > 0) {
      Object.keys(datas).some((key) => {
        if (datas[key][DIC.VALUE] === ('' + value)) {
          actions.push(datas[key][DIC.LABLE])
          return true
        }
      })
    }
    if (actions && actions.length === 0) return value
    return actions.join('')
  },

  dictValue(datas, value) {// 回显牧场
    const actions = []
    if (datas && datas.length > 0) {
      Object.keys(datas).some((key) => {
        if (datas[key][DIC.LABLE] === ('' + value)) {
          actions.push(datas[key][DIC.VALUE])
          return true
        }
      })
    }
    if (actions && actions.length === 0) return value
    return actions.join('')
  },

  dictLabels(datas, value, separator = ',') {
    const actions = []

    const temp = value.split(separator)
    if (temp && temp.length > 0) {
      Object.keys(temp).some((val) => {
        Object.keys(datas).some((key) => {
          if (datas[key][DIC.VALUE] === ('' + temp[val])) {
            actions.push(datas[key][DIC.LABLE])
          }
        })
      })
    }
    return actions.join(separator)
  },
}
export default DictUtil
